const servidorTarimba = 'https://tarimbanacozinha.com.br/tarimbaBackend/';
//const servidorTarimba = 'http://localhost/tarimbaBackend/';
export default servidorTarimba;